<template>
  <vv-desktop-tile-list
    :title="title"
    :subtitle="lessonStep.title"
    :subline="subline"
    :progression="progression"
    :total="total"
    :default="true"
  >
    <div class="TileList-Wrapper">
      <div class="Tile-Wrapper" v-for="lesson in lessons" :key="lesson.id">
        <vv-desktop-lesson-step-tile
          :title="lesson.title"
          :image="lesson.tileImage"
          :secondary="durationLabel(lesson)"
          :status="lessonStatus(lesson.id)"
          @click="openLesson(lesson.id)"
        />
      </div>
    </div>
  </vv-desktop-tile-list>
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'

import { isLessonComplete } from '@/helpers/userCompletion'

import { VvDesktopTileList, VvDesktopLessonStepTile } from '../common'

export default {
  name: 'DesktopLessonStepItem',
  components: { VvDesktopTileList, VvDesktopLessonStepTile },
  props: {
    id: {
      type: String,
      required: true
    },
    masterclassId: {
      type: String,
      required: true
    },
    lessonStep: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      masterclass: 'currentTheme',
    }),
    lessons() {
      return this.lessonStep.lessons
    },
    title() {
      if (!this.lessonStep || !this.masterclass) return null

      const index = this.masterclass.lessonSteps.findIndex(lessonStep => lessonStep.id === this.id)

      return this.$t('lessonStep.lesson_item.index', { index: index + 1 })
    },
    subline() {
      const duration = this.lessons
        .filter(lesson => Number.isSafeInteger(lesson.duration))
        .reduce((duration, lesson) => duration + lesson.duration, 0)

      return this.$tc('masterclass.notice', duration, { duration })
    },
    total() {
      return this.lessonStep.lessons.length
    },
    progression() {
      return this.lessons.reduce((sum, lesson) => (isLessonComplete(lesson.id) ? sum + 1 : sum), 0)
    }
  },
  methods: {
    /**
     * Test if the given lesson is complete
     * @param {string} lessonId
     * @returns {string}
     */
    lessonStatus(lessonId) {
      return isLessonComplete(lessonId) ? 'finished' : 'unstarted'
    },
    /**
     * Open the given lesson
     * @param {string} lessonId
     */
    openLesson(lessonId) {
      this.$router.push({
        name: 'lesson',
        params: {
          themeId: this.masterclass.id,
          lessonStepId: this.id,
          lessonId: lessonId
        }
      })
    },
    durationLabel(lesson) {
      let duration = 0

      if (lesson && Number.isSafeInteger(lesson.duration)) {
        duration = lesson.duration
      }

      return this.$tc('masterclass.notice', duration, { duration })
    }
  }
}
</script>

<style lang="scss" scoped>
.TileList-Wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  // justify-content: space-between;

  .Tile-Wrapper {
    width: calc(33% - 10px);
    height: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(:nth-of-type(3n)) {
      margin-right: 15px;
    }
  }
}
</style>
